<app-form-input
  [parentForm]="parentForm"
  [disabled]="disabled"
  [value]="attributionFromMAPA.descriptionReduite.objet"
  [label]="step2.getobjet"
  [type]="'text'"
  [rule]="'required|minSize_5|maxSize_2000'"
  [name]="getUidDescriptionReduite() + '_SepAtt_objet'"
>
</app-form-input>
<app-form-input
  [parentForm]="parentForm"
  [disabled]="disabled"
  [value]="attributionFromMAPA.autresInformations.valeurTotaleEstimee?.valeur"
  [label]="step2.getvaleurtotaleestimee"
  [type]="'number'"
  [rule]="'digits_2'"
  [name]="getUidTypeMontant() + '_SepAtt_valeur'"
>
</app-form-input>
<app-form-input
  [parentForm]="parentForm"
  [disabled]="disabled"
  [value]="attributionFromMAPA.autresInformations.valeurTotaleEstimee?.devise"
  [label]="step2.getdevise"
  [type]="'autocomplete'"
  [autoCompleteType]="'DEVISE'"
  [autoCompleteTypeIndex]="0"
  [rule]="'pattern_13'"
  [errorMessage]="{}"
  [name]="getUidTypeMontant() + '_SepAtt_devise'"
>
</app-form-input>
<app-form-input
  [parentForm]="parentForm"
  [disabled]="disabled"
  [value]="attributionFromMAPA.autresInformations.dateAttribution"
  [label]="step2.getdateattribution"
  [type]="'date'"
  [rule]="'pattern_7'"
  [name]="getUidTypeAutresInfosATTR() + '_SepAtt_dateAttribution'"
>
</app-form-input>
<app-form-input-error
  [activeForm]="parentForm"
  [name]="getStepId() + rg2" [id]="getStepId() + rg2"
></app-form-input-error>
<app-form-input-error
  [activeForm]="parentForm"
  [name]="getStepId() + rg3" [id]="getStepId() + rg3"
></app-form-input-error>
<app-form-input-error
  [activeForm]="parentForm"
  [name]="getStepId() + rg4" [id]="getStepId() + rg4"
></app-form-input-error>
<fieldset>
  <legend>
    {{ step2.getspan2 | translate }}
  </legend>
  <app-form-input
    [label]=""
    [name]="
      getUidAttribution() + '_SepSep_TypeResultatAttribution_SepAtt_infructueux'
    "
    [parentForm]="parentForm"
    [disabled]="disabled"
    [type]="'radio'"
    [rule]="'pattern_29|required'"
    [errorMessage]="{ required: 'ctr_300' }"
    [radios]="[
      {
        value: infructueux,
        label: step2.getinfructueux
      },
      {
        value: sansSuite,
        label: step2.getsanssuite
      },
      {
        value: attribueUnique,
        label: step2.getattribueunique
      },
      {
        value: attribueLots,
        label: step2.getattribueparlots
      },
      {
        value: lotsInfructueux,
        label: step2.getspan3
      }
    ]"
    [value]="radioButtonValue"
  >
  </app-form-input>
  {{ step2.getspan4 | translate }}
</fieldset>
